/**
 * Get List
 */
export const WEB_JOURNAL_ARTICLE_LIST = "web/WEB_JOURNAL_ARTICLE_LIST";
export const WEB_JOURNAL_ARTICLE_LIST_SUCCESS = "web/WEB_JOURNAL_ARTICLE_LIST_SUCCESS";
export const WEB_JOURNAL_ARTICLE_LIST_FAILURE = "web/WEB_JOURNAL_ARTICLE_LIST_FAILURE";


/**
 * Get by id
 */
export const WEB_JOURNAL_ARTICLE_DETAIL = "web/WEB_JOURNAL_ARTICLE_DETAIL";
export const WEB_JOURNAL_ARTICLE_DETAIL_SUCCESS = "web/WEB_JOURNAL_ARTICLE_DETAIL_SUCCESS";
export const WEB_JOURNAL_ARTICLE_DETAIL_FAILURE = "web/WEB_JOURNAL_ARTICLE_DETAIL_FAILURE";


/**
 * UploadED file LIST
 */
export const WEB_ARTICLE_FILE_DETAIL = "WEB_ARTICLE_FILE_DETAIL";
export const WEB_ARTICLE_FILE_DETAIL_SUCCESS = "WEB_ARTICLE_FILE_DETAIL_SUCCESS";
export const WEB_ARTICLE_FILE_DETAIL_FAILURE = "WEB_ARTICLE_FILE_DETAIL_FAILURE";